import { Controller } from "@hotwired/stimulus"

/**
 * LEGACY side panel controller — kept for posts/newsletters selection_receiver pattern.
 * Uses a div with transform (not <dialog>) so the turbo-frame inside stays
 * accessible to external links even when the panel is closed.
 *
 * To be replaced by the new SidePanelComponent (<dialog>-based) once
 * the selection_receiver pattern is migrated to per-element side panels.
 * See Jira ticket for migration plan.
 */
export default class extends Controller {
  static targets = ["container", "closeButton", "backdrop"]

  connect() {
    this.opened = false
  }

  open(event) {
    // Ce panneau est le seul à répondre aux événements anonymes : `selection_receiver` diffuse sans
    // id pour l'ouvrir. Un événement nommé s'adresse forcément à un autre panneau — sans cette
    // garde, ouvrir l'éditeur de composition ouvre aussi le sélecteur de contenus.
    if (event?.detail?.id) return

    if (this.opened) return
    this.opened = true
    this.backdropTarget.classList.remove("hidden")
    this.containerTarget.classList.remove("translate-x-full")
    this.closeButtonTarget.classList.remove("hidden")
  }

  close() {
    if (!this.opened) return
    this.opened = false
    this.backdropTarget.classList.add("hidden")
    this.containerTarget.classList.add("translate-x-full")
    this.closeButtonTarget.classList.add("hidden")
  }
}
